module.exports = __webpack_public_path__ + "static/media/orange.530277f5.svg";